module.exports = __webpack_public_path__ + "img/OK_icon.5bd95afb.svg";